import React, { createContext, createRef, useContext } from 'react';
import PropTypes from 'prop-types';

const ScrollContext = createContext();
const chatBoxRef = createRef();

export const ScrollContextProvider = props => {
  return (
    <ScrollContext.Provider value={{ chatBoxRef }}>
      {props.children}
    </ScrollContext.Provider>
  );
};

ScrollContextProvider.propTypes = {
  children: PropTypes.node,
  posts: PropTypes.array,
};

export const useScrollContext = () => useContext(ScrollContext);
